import { Box, IconButton, Input, InputGroup, InputRightElement } from "@chakra-ui/react"
import { Dispatch, SetStateAction, useRef } from "react"
import { CClose, CFilter } from "./Icons"

type Props = {
  filterValue: string
  setFilterValue: Dispatch<SetStateAction<string>>
  placeholder: string
}

const InputFilter = ({ filterValue, setFilterValue, placeholder }: Props) => {
  const filterInputRef = useRef(null)

  const handleOnChange = (value: string) => setFilterValue(value)

  const handleClearButtonClick = () => {
    setFilterValue("")
    filterInputRef.current.focus()
  }

  return (
    <Box w={{ base: "100%", sm: "72" }}>
      <InputGroup>
        <Input
          ref={filterInputRef}
          variant="filled"
          h={{ base: "11", md: "10" }}
          w={{ base: "100%", sm: "72" }}
          px="2"
          value={filterValue}
          _focusVisible={{}}
          onChange={(e) => {
            handleOnChange(e.target.value)
          }}
          placeholder={placeholder}
        />

        <InputRightElement height={{ base: "11", md: "10" }} pointerEvents={filterValue ? "auto" : "none"}>
          {filterValue ? (
            <IconButton
              icon={<CClose />}
              aria-label="Clear filter text"
              onClick={handleClearButtonClick}
              bgColor="transparent"
              _hover={{ bgColor: "transparent" }}
              _active={{ bgColor: "transparent", color: "black" }}
            />
          ) : (
            <CFilter />
          )}
        </InputRightElement>
      </InputGroup>
    </Box>
  )
}

export default InputFilter
